import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebaseConfig";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function Haberler() {
  const [haberler, setHaberler] = useState([]);
  const [popupHaber, setPopupHaber] = useState(null); // Düzenleme popup'ı için
  const [addPopupVisible, setAddPopupVisible] = useState(false); // Yeni haber ekleme popup'ı için
  const [sortCriteria, setSortCriteria] = useState(null); // sıralama kriteri
const [sortOrder, setSortOrder] = useState("asc"); // sıralama düzeni ("asc" veya "desc")
const [filterPopupVisible, setFilterPopupVisible] = useState(false); // filtre popup


const sortHaberler = (criteria, order) => {
  const sortedHaberler = [...haberler].sort((a, b) => {
    if (criteria === "anahaber_baslik") {
      return order === "asc"
        ? a[criteria].localeCompare(b[criteria])
        : b[criteria].localeCompare(a[criteria]);
    }
    if (criteria === "anahaber_tarih" || criteria === "anahaber_gorsayisi") {
      return order === "asc"
        ? new Date(a[criteria]) - new Date(b[criteria])
        : new Date(b[criteria]) - new Date(a[criteria]);
    }
    return 0;
  });
  setHaberler(sortedHaberler);
};



  const [newHaber, setNewHaber] = useState({
    anahaber_baslik: "",
    anahaber_icerik: "",
    anahaber_img: "",
    anahaber_gorsayisi: 0,
    anahaber_begenisayisi: 0,
    anahaber_sonislemtarih: "",
    anahaber_tarih: new Date().toISOString(),
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null); // Silme onayı için

  // Firestore'dan haberleri çekme
  useEffect(() => {
    const fetchHaberler = async () => {
      const querySnapshot = await getDocs(collection(db, "buyuksehir_anahaber"));
      const now = new Date();
      const filteredHaberler = querySnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter(
          (haber) =>
            new Date(haber.startDate) <= now && new Date(haber.endDate) >= now
        );
  
      setHaberler(filteredHaberler);
    };
    fetchHaberler();
  }, []);
  // Görsel seçme ve önizleme
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        toast.error("Lütfen bir görsel dosyası seçin.");
        return;
      }
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  // Görsel yükleme işlemi
  const uploadImage = async (file) => {
    if (!file) return null;
    const storageRef = ref(storage, `haberler/${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  };

  // Yeni haber ekleme
  const handleAddHaber = async () => {
    try {
      const imgUrl = await uploadImage(file); // Görseli yükle ve URL'yi al
      const docRef = await addDoc(collection(db, "buyuksehir_anahaber"), {
        ...newHaber,
        anahaber_img: imgUrl || "",
        anahaber_tarih: new Date().toISOString(),
        startDate: new Date(newHaber.startDate).toISOString(), // Başlangıç tarihi
        endDate: new Date(newHaber.endDate).toISOString(), // Bitiş tarihi
      });
  
      await updateDoc(doc(db, "buyuksehir_anahaber", docRef.id), {
        id: docRef.id,
      });
  
      setHaberler((prev) => [
        ...prev,
        { id: docRef.id, ...newHaber, anahaber_img: imgUrl },
      ]);
      toast.success("Haber başarıyla eklendi!");
      setAddPopupVisible(false);
      setNewHaber({
        anahaber_baslik: "",
        anahaber_icerik: "",
        anahaber_img: "",
        anahaber_gorsayisi: 0,
        anahaber_begenisayisi: 0,
        anahaber_sonislemtarih: "",
        anahaber_tarih: new Date().toISOString(),
        startDate: "",
        endDate: "",
      });
      setFile(null);
      setPreview(null);
    } catch (error) {
      console.error("Haber eklenirken hata oluştu:", error);
      toast.error("Haber eklenirken bir hata oluştu!");
    }
  };

  // Haber güncelleme
  const handleUpdate = async (id, updatedHaber) => {
    try {
      let updatedImageUrl = popupHaber.anahaber_img;

      if (file) {
        updatedImageUrl = await uploadImage(file); // Yeni görsel yükleme
      }

      const haberRef = doc(db, "buyuksehir_anahaber", id);
      await updateDoc(haberRef, {
        ...updatedHaber,
        anahaber_img: updatedImageUrl,
        anahaber_sonislemtarih: new Date().toISOString(),
      });

      setHaberler((prev) =>
        prev.map((haber) =>
          haber.id === id
            ? { id, ...updatedHaber, anahaber_img: updatedImageUrl }
            : haber
        )
      );
      toast.success("Haber başarıyla güncellendi!");
      setPopupHaber(null);
      setFile(null);
      setPreview(null);
    } catch (error) {
      console.error("Haber güncellenirken hata oluştu:", error);
      toast.error("Haber güncellenirken bir hata oluştu!");
    }
  };

  // Haber silme
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "buyuksehir_anahaber", id));
      setHaberler((prev) => prev.filter((haber) => haber.id !== id));
      toast.success("Haber başarıyla silindi!");
      setConfirmDelete(null);
    } catch (error) {
      console.error("Haber silinirken hata oluştu:", error);
      toast.error("Haber silinirken bir hata oluştu!");
    }
  };

  return (
    <div className="min-h-screen bg-sky-100 p-8 rounded shadow">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-extrabold text-gray-700">Haberler</h1>
          <div className="flex space-x-4">
          <button
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg shadow"
              onClick={() => setFilterPopupVisible(true)}
            >
              Filtrele ve Sırala
            </button>
            <button
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg shadow-md"
              onClick={() => setAddPopupVisible(true)}
            >
              Yeni Haber Ekle
            </button>

          </div>
        </div>  
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {haberler.map((haber) => (
          <div
            key={haber.id}
            className="bg-white shadow-lg rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300"
          >
            <img
              src={haber.anahaber_img || "https://via.placeholder.com/150"}
              alt={haber.anahaber_baslik}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="font-bold text-lg text-gray-800 mb-2">{haber.anahaber_baslik}</h2>
              <p className="text-gray-600 text-sm">{haber.anahaber_icerik?.slice(0, 100)}...</p>
              <div className="flex justify-between mt-4">
                <button
                  className="bg-blue-500 text-white px-3 py-1 rounded-md"
                  onClick={() => setPopupHaber(haber)}
                >
                  Düzenle
                </button>
                <button
                  className="bg-red-500 text-white px-3 py-1 rounded-md"
                  onClick={() => setConfirmDelete(haber.id)}
                >
                  Sil
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filterPopupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Sıralama Seçenekleri</h2>
            <label className="block mb-2">Kriter Seçin:</label>
            <select
              className="w-full p-2 border rounded-lg mb-4"
              onChange={(e) => setSortCriteria(e.target.value)}
              value={sortCriteria || ""}
            >
              <option value="">Seçiniz</option>
              <option value="anahaber_baslik">Başlık (A-Z)</option>
              <option value="anahaber_gorsayisi">Gösterim Sayısı</option>
              <option value="anahaber_tarih">Tarih</option>
            </select>

            <label className="block mb-2">Sıralama Düzeni:</label>
            <select
              className="w-full p-2 border rounded-lg mb-4"
              onChange={(e) => setSortOrder(e.target.value)}
              value={sortOrder || "asc"}
            >
              <option value="asc">Artan</option>
              <option value="desc">Azalan</option>
            </select>

            <div className="flex justify-end">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow mr-2"
                onClick={() => {
                  sortHaberler(sortCriteria, sortOrder);
                  setFilterPopupVisible(false);
                }}
              >
                Uygula
              </button>
              <button
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg shadow"
                onClick={() => setFilterPopupVisible(false)}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Düzenleme Popup */}
      {popupHaber && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-lg">
            <h2 className="text-2xl font-bold text-gray-700 mb-4">Haberi Düzenle</h2>
            <input
              type="text"
              className="w-full p-3 border rounded-lg mb-4"
              value={popupHaber.anahaber_baslik || ""}
              onChange={(e) =>
                setPopupHaber({ ...popupHaber, anahaber_baslik: e.target.value })
              }
            />
            <ReactQuill
              value={popupHaber.anahaber_icerik || ""}
              onChange={(value) =>
                setPopupHaber({ ...popupHaber, anahaber_icerik: value })
              }
              className="mb-4"
            />
            <label className="block mb-2 text-gray-700">Gösterim Başlangıç Tarihi</label>
              <input
                type="date"
                className="w-full p-3 border rounded-lg mb-4"
                value={popupHaber.startDate?.split("T")[0] || ""}
                onChange={(e) =>
                  setPopupHaber({ ...popupHaber, startDate: e.target.value })
                }
              />

              <label className="block mb-2 text-gray-700">Gösterim Bitiş Tarihi</label>
              <input
                type="date"
                className="w-full p-3 border rounded-lg mb-4"
                value={popupHaber.endDate?.split("T")[0] || ""}
                onChange={(e) =>
                  setPopupHaber({ ...popupHaber, endDate: e.target.value })
                }
              />

            <div className="mb-4">
              <img
                src={popupHaber.anahaber_img || "https://via.placeholder.com/150"}
                alt="Eski Görsel"
                className="w-full h-48 object-cover rounded-lg"
              />
              <label
                htmlFor="updateFileInput"
                className="w-full h-20 border-2 border-dashed flex items-center justify-center rounded-md cursor-pointer hover:bg-gray-100 mt-4"
              >
                <span className="text-gray-500">Yeni görsel yüklemek için tıklayın</span>
                <input
                  id="updateFileInput"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="hidden"
                />
              </label>
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  className="w-full h-48 object-cover rounded-lg mt-4"
                />
              )}
            </div>
            <div className="flex justify-end">
              <button
                className="bg-green-500 text-white px-5 py-2 rounded-lg shadow mr-2"
                onClick={() => handleUpdate(popupHaber.id, popupHaber)}
              >
                Kaydet
              </button>
              <button
                className="bg-red-500 text-white px-5 py-2 rounded-lg shadow"
                onClick={() => setPopupHaber(null)}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Yeni Haber Ekle Popup */}
      {addPopupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-lg">
            <h2 className="text-2xl font-bold text-gray-700 mb-4">Yeni Haber Ekle</h2>
            <input
              type="text"
              className="w-full p-3 border rounded-lg mb-4"
              placeholder="Başlık"
              value={newHaber.anahaber_baslik}
              onChange={(e) =>
                setNewHaber({ ...newHaber, anahaber_baslik: e.target.value })
              }
            />
            <ReactQuill
              value={newHaber.anahaber_icerik}
              onChange={(value) => setNewHaber({ ...newHaber, anahaber_icerik: value })}
              className="mb-4"
            />
                        <label className="block mb-2 text-gray-700">Gösterim Başlangıç Tarihi</label>
                  <input
                    type="date"
                    className="w-full p-3 border rounded-lg mb-4"
                    value={newHaber.startDate || ""}
                    onChange={(e) =>
                      setNewHaber({ ...newHaber, startDate: e.target.value })
                    }
                  />

                  <label className="block mb-2 text-gray-700">Gösterim Bitiş Tarihi</label>
                  <input
                    type="date"
                    className="w-full p-3 border rounded-lg mb-4"
                    value={newHaber.endDate || ""}
                    onChange={(e) =>
                      setNewHaber({ ...newHaber, endDate: e.target.value })
                    }
                  />
            <label
              htmlFor="fileInput"
              className="w-full h-20 border-2 border-dashed flex items-center justify-center rounded-md cursor-pointer hover:bg-gray-100"
            >
              <span className="text-gray-500">Görsel yüklemek için tıklayın</span>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>
            {preview && (
              <img src={preview} alt="Preview" className="w-full h-48 object-cover rounded-lg mt-4" />
            )}
            <div className="flex justify-end mt-4">
              <button
                className="bg-blue-500 text-white px-5 py-2 rounded-lg shadow mr-2"
                onClick={handleAddHaber}
              >
                Ekle
              </button>
              <button
                className="bg-red-500 text-white px-5 py-2 rounded-lg shadow"
                onClick={() => setAddPopupVisible(false)}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Silme Onayı Popup */}
      {confirmDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
            <h2 className="text-xl font-bold mb-4 text-gray-800">Haber Sil</h2>
            <p className="mb-6 text-gray-600">Bu haberi silmek istediğinize emin misiniz?</p>
            <div className="flex justify-end">
              <button
                className="bg-red-500 text-white px-5 py-2 rounded-lg shadow mr-2"
                onClick={() => handleDelete(confirmDelete)}
              >
                Sil
              </button>
              <button
                className="bg-gray-300 text-gray-700 px-5 py-2 rounded-lg shadow"
                onClick={() => setConfirmDelete(null)}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

    
  );
}

export default Haberler;
